import { render, staticRenderFns } from "./StakingData.vue?vue&type=template&id=15a5f709&scoped=true&"
import script from "./StakingData.vue?vue&type=script&lang=js&"
export * from "./StakingData.vue?vue&type=script&lang=js&"
import style0 from "./StakingData.vue?vue&type=style&index=0&id=15a5f709&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a5f709",
  null
  
)

export default component.exports